import React, { Component } from 'react';
import serverClientUtil from '../../../../utils/serverClientUtil';

class NewItemInnerMainMenu extends Component {
  render() {
    const { data } = this.props;
    const displayList = data && data.children;

    return (
      <div key={data.title}>
        <h3 className="titleBlockOfSubProducts">
          {data.title}
        </h3>
        <div className="blockOfSubProducts">
          {displayList &&
            displayList.map((item, i) => {
              const isLastItem = i === 7;
              if (i >= 8) return false;
              return (
                <div key={item.title}>
                  <a
                    href={`${serverClientUtil.getLPURL()}${item?.viewUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title}
                  </a>
                  {isLastItem && (
                    <a
                      href={`${serverClientUtil.getLPURL()}${data?.viewUrl}`}
                      target="_blank"
                      className="showMoreLink"
                      rel="noopener noreferrer"
                      style={{ color: '#E10098' }} // TODO: Dinamic brand color
                    >
                      Ver más +
                    </a>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default NewItemInnerMainMenu;
